import * as React from 'react';
import SharedCalendarsFull from './components/SharedCalendarsFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import isSharedCalendarsOptionDirty from './utils/isSharedCalendarsOptionDirty';
import saveSharedCalendarOption from './orchestration/saveSharedCalendarOption';
import discardSharedCalendarOption from './data/mutators/discardSharedCalendarOption';
var SharedCalendarsOption = {
    key: 'sharedCalendars',
    titleStringKey: 'optionTitle_shareACalendar',
    searchTermsStringKey: 'optionTitle_shareACalendar',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SharedCalendarsFull, null); },
        isDirty: isSharedCalendarsOptionDirty,
        onSave: saveSharedCalendarOption,
        onDiscard: discardSharedCalendarOption,
    },
    isHidden: function () { return !isControlFeatureEnabled('cal-sharing-settings'); },
};
export default SharedCalendarsOption;
//# sourceMappingURL=SharedCalendarsOption.js.map